<template>

  <div class="d-flex ga-3 justify-space-between">

    <div style="max-width: 360px;">

      <o-select
        v-model.number="v$.days.$model"
        :validator="v$.days"
        :items="spotheroFlexDiscountDurations"
        :prefix="daysPrefix"
        :suffix="daysSuffix"
        density="compact"
        persistent-placeholder
      />

    </div>

    <div>

      <div class="d-flex ga-3">

        <o-text-field
          v-model.number="v$.percentage.$model"
          :validator="v$.percentage"
          type="number"
          min="0"
          max="99"
          step="1"
          :suffix="'% off'"
          density="compact"
          persistent-placeholder
        />

        <v-btn
          icon="$delete"
          size="small"
          @click="$emit('deleteClicked')"
        />

      </div>

    </div>

  </div>

</template>

<script setup lang="ts">

import { type FlexDiscountRow, spotheroFlexDiscountDurations } from './types'

import useVuelidate from '@vuelidate/core'
import { helpers } from '@vuelidate/validators'
import { required, minValue, maxValue, integer } from '../../../../utils/i18n-validators'

defineEmits(['deleteClicked'])

/**
 * Props
 */

interface Props {
  daysPrefix?: string
  daysSuffix?: string
  otherRowDays: number[]
}

const props = defineProps<Props>()

const model = defineModel<FlexDiscountRow>({ required: true })

const formRules = {
  days: {
    required,
    integer,
    minValue: minValue(1),
    maxValue: maxValue(28),
    noDuplicateDays: helpers.withMessage(
      'Duplicate',
      (value: any) => {
        if (!helpers.req(value)) {
          return true
        }
        return !props.otherRowDays.includes(value)
      }
    ),
  },
  percentage: {
    required,
    integer,
    minValue: minValue(0),
    maxValue: maxValue(99),
  },
}

const v$ = useVuelidate(formRules, model)

</script>
